module.exports = __webpack_public_path__ + "static/media/paid_ru.6980c01d.svg";